export class typeM{
    CLIENT_ID: number;
    ID: number;
    NAME: string;
    ICON: string;
    IS_ACTIVE: boolean;
}